__turbopack_context__.v({
  "container": "CategoriesBlogSection-module-scss-module___12Ona__container",
  "slide": "CategoriesBlogSection-module-scss-module___12Ona__slide",
  "spacingBottom": "CategoriesBlogSection-module-scss-module___12Ona__spacingBottom",
});
